import { principles } from '@/mocks/campusData';

const darkKicker = {
  kicker: '内容原则',
  title: '我们凭什么敢做“求真复盘”？',
  desc: '吃瓜也要守得住底线。关于信息的边界、立场与责任感，这几条原则写在前面，接受所有人监督。',
};

export default function Principles() {
  return (
    <section id="principle" className="bg-stone-900 py-12 text-stone-100 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <p className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-red-400">
            <span className="inline-block h-px w-6 bg-red-400" />
            {darkKicker.kicker}
          </p>
          <h2 className="font-editorial text-2xl font-black leading-snug text-white md:text-3xl">
            {darkKicker.title}
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-stone-300 md:text-base">
            {darkKicker.desc}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div
              key={p.title}
              className="rounded-xl border border-white/10 bg-white/5 p-5 transition hover:border-red-400/60 hover:bg-white/10"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-red-600/90 text-xl text-white">
                <i className={p.icon} />
              </span>
              <h3 className="mt-4 text-base font-bold text-white">{p.title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-stone-300">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-xl border border-white/10 bg-white/5 p-5 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-teal-500 text-lg text-stone-900">
              <i className="ri-shield-check-line" />
            </span>
            <div>
              <p className="text-sm font-bold text-white">遇到伤害性谣言，我们的态度</p>
              <p className="text-xs text-stone-300">不扩散、不渲染，第一时间提示保留证据与举报/维权路径。</p>
            </div>
          </div>
          <a
            href="#faq"
            className="whitespace-nowrap rounded-md border border-white/20 px-4 py-2 text-sm font-medium text-white transition hover:border-red-400 hover:bg-red-600"
          >
            查看吃瓜指南 FAQ
          </a>
        </div>
      </div>
    </section>
  );
}